import { render } from "./BuscaPessoaAntt.vue?vue&type=template&id=8f56c21a&scoped=true"
import script from "./BuscaPessoaAntt.vue?vue&type=script&lang=ts"
export * from "./BuscaPessoaAntt.vue?vue&type=script&lang=ts"

import "./BuscaPessoaAntt.vue?vue&type=style&index=0&id=8f56c21a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8f56c21a"

export default script